export const DASH_PENDING_CANCELLATIONS_GRID_CONFIG_ID = 'dash-pending-cancellations'

export const DASH_PENDING_CANCELLATIONS_GRID_CONFIG = {
  id: DASH_PENDING_CANCELLATIONS_GRID_CONFIG_ID,
  layout: {
    xl: { i: DASH_PENDING_CANCELLATIONS_GRID_CONFIG_ID, x: 4.95, y: 3, w: 2.09, h: 3, static: true },
    lg: { i: DASH_PENDING_CANCELLATIONS_GRID_CONFIG_ID, x: 9, y: 3, w: 3, h: 3, static: true },
    md: { i: DASH_PENDING_CANCELLATIONS_GRID_CONFIG_ID, x: 0, y: 6, w: 4, h: 3, static: true },
    sm: { i: DASH_PENDING_CANCELLATIONS_GRID_CONFIG_ID, x: 8.5, y: 9, w: 12, h: 1.85, static: true },
    xs: { i: DASH_PENDING_CANCELLATIONS_GRID_CONFIG_ID, x: 0, y: 9, w: 12, h: 1.75, static: true },
    xxs: { i: DASH_PENDING_CANCELLATIONS_GRID_CONFIG_ID, x: 0, y: 8.2, w: 12, h: 1.75, static: true }
  }
}
